import "./theme.styl"

import DefaultLayout from "@/layouts/default/default.js"
import Gallery from "@/components/gallery/gallery.js"

// Init before DOMContentLoaded
DefaultLayout.init()

// Init after DDOMContentLoadedOM
document.addEventListener("DOMContentLoaded", () => {
    Gallery.init()
})
